<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="自动生成的编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'number', validatorRules.number]" placeholder="请输入自动生成的编号"></a-input>
        </a-form-item>
        <a-form-item label="处理状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'statusCode', validatorRules.statusCode]" placeholder="请输入处理状态"></a-input>
        </a-form-item>
        <a-form-item label="反馈区域" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'areaCode', validatorRules.areaCode]" placeholder="请输入反馈区域"></a-input>
        </a-form-item>
        <a-form-item label="反馈项目" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'projectCode', validatorRules.projectCode]" placeholder="请输入反馈项目"></a-input>
        </a-form-item>
        <a-form-item label="反馈类别" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'typeCode', validatorRules.typeCode]" placeholder="请输入反馈类别"></a-input>
        </a-form-item>
        <a-form-item label="反馈人" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'fbUserCode', validatorRules.fbUserCode]" placeholder="请输入反馈人"></a-input>
        </a-form-item>
        <a-form-item label="反馈内容" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'fbContent', validatorRules.fbContent]" placeholder="请输入反馈内容"></a-input>
        </a-form-item>
        <a-form-item label="处理人" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'dealUserCode', validatorRules.dealUserCode]" placeholder="请输入处理人"></a-input>
        </a-form-item>
        <a-form-item label="处理回复" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'dealContent', validatorRules.dealContent]" placeholder="请输入处理回复"></a-input>
        </a-form-item>
        <a-form-item label="反馈图片列表" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'fbImglist', validatorRules.fbImglist]" placeholder="请输入反馈图片列表"></a-input>
        </a-form-item>
        <a-form-item label="开始受理时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-date placeholder="请选择开始受理时间" v-decorator="[ 'dealBeginTime', validatorRules.dealBeginTime]" :trigger-change="true" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="处理结束时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-date placeholder="请选择处理结束时间" v-decorator="[ 'dealEndTime', validatorRules.dealEndTime]" :trigger-change="true" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="是否评价" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="[ 'appraiseIs', validatorRules.appraiseIs]" placeholder="请输入是否评价" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="及时性评价1-5" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="[ 'appraiseTimely', validatorRules.appraiseTimely]" placeholder="请输入及时性评价1-5" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="满意度评价1-5" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="[ 'appraiseSatis', validatorRules.appraiseSatis]" placeholder="请输入满意度评价1-5" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="评价时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-date placeholder="请选择评价时间" v-decorator="[ 'appraiseTime', validatorRules.appraiseTime]" :trigger-change="true" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="是否删除0否，1是" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="[ 'delFlag', validatorRules.delFlag]" placeholder="请输入是否删除0否，1是" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="处理图片列表" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'dealImglist', validatorRules.dealImglist]" placeholder="请输入处理图片列表"></a-input>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDate from '@/components/jeecg/JDate'  

  export default {
    name: "FeedbackContentModal",
    components: { 
      JDate,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          number: {rules: [
          ]},
          statusCode: {rules: [
          ]},
          areaCode: {rules: [
          ]},
          projectCode: {rules: [
          ]},
          typeCode: {rules: [
          ]},
          fbUserCode: {rules: [
          ]},
          fbContent: {rules: [
          ]},
          dealUserCode: {rules: [
          ]},
          dealContent: {rules: [
          ]},
          fbImglist: {rules: [
          ]},
          dealBeginTime: {rules: [
          ]},
          dealEndTime: {rules: [
          ]},
          appraiseIs: {rules: [
            {required: true, message: '请输入是否评价!'},
          ]},
          appraiseTimely: {rules: [
          ]},
          appraiseSatis: {rules: [
          ]},
          appraiseTime: {rules: [
          ]},
          delFlag: {rules: [
            {required: true, message: '请输入是否删除0否，1是!'},
          ]},
          dealImglist: {rules: [
          ]},
        },
        url: {
          add: "/administration/base/feedbackContent/add",
          edit: "/administration/base/feedbackContent/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'number','statusCode','areaCode','projectCode','typeCode','fbUserCode','fbContent','dealUserCode','dealContent','fbImglist','dealBeginTime','dealEndTime','appraiseIs','appraiseTimely','appraiseSatis','appraiseTime','delFlag','dealImglist'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'number','statusCode','areaCode','projectCode','typeCode','fbUserCode','fbContent','dealUserCode','dealContent','fbImglist','dealBeginTime','dealEndTime','appraiseIs','appraiseTimely','appraiseSatis','appraiseTime','delFlag','dealImglist'))
      },

      
    }
  }
</script>